;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/PictureStyleBox',["jquery", "eventManager", "score_bootstrap/Base/PictureAsBackground"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require("score_bootstrap/Base/PictureAsBackground")) :
    console && console.error('PictureStyleBox does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, PictureAsBackground) {
    
    function PictureStyleBox(scope, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
        ///<summary>Initialize a new instance of StyleBox. Subscribe to messages which are passed to current instance.</summary>

        var self = this;

        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });
        Object.defineProperty(this, "stateChangeMessages", { enumerable: !0, value: stateChangeMessages.slice() });

        //#region show messages performer
        if (onShowMessagesPerformer.length) {
            onShowMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.show, self);
            });

        }
        //#endregion


        //#region hide mesage performer
        if (onHideMessagePerformer.length) {
            onHideMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.hide, self);
            });
        }
        //#endregion

        PictureAsBackground.call(this, scope, '> picture', '> .score-editField-group > .pic-thumb > picture');

    }

    PictureStyleBox.prototype = Object.create(PictureAsBackground.prototype);

    PictureStyleBox.prototype.show = function () {
        ///<summary>Make StyleBox visible with jQuery.show() method.</summary>
        this.$scope.show();

        var self = this;
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    PictureStyleBox.prototype.hide = function () {
        ///<summary>Make StyleBox hidden with jQuery.hide() method.</summary>
        this.$scope.hide();

        var self = this;
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    PictureStyleBox.init = function init(args) {
        return new PictureStyleBox(args.scope,
                                   args.StateChangeMessagesTransmitting || [],
                                   args.ShowActionMessages || [],
                                   args.HideActionMessages || []);
    };

    return PictureStyleBox;
}));
